import React, {Component} from 'react';
import {Carousel} from 'react-bootstrap';
import esnStar from '../images/esnLogo512.png'
import $ from 'jquery';
import Loading from './Loading.js';
import ProgressiveImage from './ProgressiveImageSimple';
const teamMembers=[
    {
        name:'Bartosz Adamowicz',
        position:'President',
        description:<div>
            Hi guys, my name is Bartek. I study Computer Science and I also work as a programmer.  <br/><br/>
            Technology is one of my biggest passions. Apart from that, I'm kind of a bookworm (I keep track of books that I've read on Goodreads). I also really like sports, currently getting better at running is my main goal, but I used to go to the gym a lot in the past. I also like playing team games from time to time, mostly volleyball or basketball. And finally - PRO8L3M is my favourite hip hop band 😎
        </div>,
        photo:'bartek.jpg',
        minPhoto:'bartek.jpg',
        mail:'president.sggw@esn.pl'
    },
    {
        name:'Marta Pliszka',
        position:'Vicepresident',
        description:<div>
            Hi! I’m Marta, a freshly baked SGGW graduate with a degree in Spatial Engineering and a great passion for Urban planning & architecture.<br/><br/>

            I enjoy long walks, hikes, Pilates and yoga so if you’re down for any of that I know we’ll get along:) I have a deep passion for dog training, I’m a beginner art lover and also plan on taking up painting soon. Baking is also one of my hobbies as I find it a great way to turn my mind off. Bonus points for some newly found R&B tunes in the background
        </div>,
        photo:'marta.jpg',
        minPhoto:'marta.jpg',
        mail:'vicepresident.sggw@esn.pl'
    },
    {
        name:'Krystian Ostrowski',
        position:'Treasurer',
        description: <div>
            Man of many mysteries...
        </div>,
        photo:'krystian.jpg',
        minPhoto:'krystian.jpg',
        mail:'treasurer.sggw@esn.pl'
    },
    {
        name:'Rafał Lisiecki',
        position:'Human Resources Manager',
        description:<div>
            Man of many mysteries...
        </div>,
        photo:'rafal.jpg',
        minPhoto:'rafal.jpg',
        mail:'hr.sggw@esn.pl'
    },
    {
        name:'Otylia Chmal',
        position:'Project Manager',
        description:<div>
            Hi! My name is Otylka 🖤 I’m currently studying Management and Physiotherapy at two different universities — because apparently, one path wasn’t enough for me 😅 — while also working as a sales representative 💼<br/><br/>
            I’ve always had a lot of different passions. I used to play the piano professionally 🎹 and trained in indoor climbing 🧗‍♀️. These days, I also spend a lot of my time sewing and creating my own clothes — I love being able to turn an idea into something completely unique 🧵✨<br/><br/>
            I’m a huge fan of gothic music 🖤🎶, but I also love having fun and enjoying life. One of my favourite things is spending time with my friends — going out to bars, singing karaoke, dancing, and just having a good time 💃🍸
        </div>,
        photo:'otylia.jpg',
        minPhoto:'otylia.jpg',
        mail:'pm.sggw@esn.pl'
    },
    {
        name:'Igor Kucharski',
        position:'Communication Manager',
        description:<div>
Hey! I’m Igor, the Communication Manager – which basically means I get to talk, write, and post the things you see on our Instagram and stuff 😎<br/>

I study Computer Science, spend a probably unhealthy amount of time listening to music, and occasionally pretend I can play piano and guitar. I love discovering albums from pretty much every genre imaginable, so there’s a decent chance I’ll go from indie rock to hardcore punk to some obscure electronic album without thinking twice.<br/>

Outside of that, I’m a football and geography nerd — for some reason, I know the flag of every country in the world. I also enjoy movies, with Pixar’s Cars holding a special place in my heart 💙
        </div>,
        photo:'igork.jpg',
        minPhoto:'igork.jpg',
        mail:'pr.sggw@esn.pl'
    },
]
const boaMembers = [
    {
        name:'Tomasz Ossowski',
        position:'Board of Audit Member',
        description:<div>
            Hi, my name is Tomasz! I’m an Environmental Engineering student and I work in HR.<br/>
            Outside of ESN, I’m a huge fan of George R. R. Martin’s A Song of Ice and Fire series (I’m still waiting and hoping for the next books). I’m also really into tabletop RPGs, especially Dungeons & Dragons and Pathfinder.<br/>
            Apart from my local section, I also volunteer on the national level of ESN, where I’m currently a member of the National Board as Vice President for Governance. When I’m not dealing with ESN documents and governance, you’ll probably find me playing a D&D session, reading fantasy or falling down another rabbit hole of fictional lore.
        </div>,
        photo:'tomek.jpg',
        minPhoto:'tomek.jpg',
        mail:'kr.sggw@esn.pl'
    },
    {
        name:'Sebastian Zellah',
        position:'Board of Audit Member',
        description:<div>
            Hey, I'm Sebastian. I went to Pisa, Italy for my Erasmus.
            I also really like cycling, this year I even cycled from Warsaw to Gdańsk.<br/>
            Hope to see you on our events and trips 🙂
        </div>,
        photo:'sebastian2.jpg',
        minPhoto:'sebastian2.jpg',
        mail:'kr.sggw@esn.pl'
    },
]
const coordinators = [
    {
        name:'Sohpie Czerwiec',
        position:'Events Coordinator',
        description:<div>
            Hey!<br/>
            Sophie here, and I’m the Events Coordinator this year! 🩷<br/>
            At our university, I study Dietetics, but I also have plans to start another major 😛<br/>
            To be honest, studying is one of the biggest parts of my life right now. I also work as a social media specialist. When it comes to my hobbies and interests — before university (when I had much more free time, haha), I used to be a hip-hop dancer 🪩 and a horse rider 🏇<br/>
            Nowadays, I sometimes go to the gym and read books. But oh my goodness… I’m the biggest fan of dragons! I LOVE DRAGONS. 🐉<br/>
            Enough about me! I hope you have an amazing time here at our university during your Erasmus stay. See you soon at our events! 🩷<br/><br/>
            ~ Sophie 🩷

</div>,
        photo:'sophie.jpg',
        minPhoto:'sophie.jpg',
        mail: <div>events.sggw@esn.pl</div>
    },
    {
        name:'Lena Kaczmarek',
        position:'Events Coordinator',
        description:<div>
            Hi!! I'm Lena and I'm 2nd year Dietetics student.<br/>
            Currently, I’m still trying to find myself, so I’m exploring lots of new things. However, some things remain constant — my love for books, hiking, and playing the guitar (amateurishly, especially around a bonfire). When it comes to music, I’m probably listening to an artist I hadn’t even heard of a month ago 😬 I also love to travel — visiting new places and experiencing different realities is one of my biggest passions 😌
        </div>,
        photo:'lena.jpg',
        minPhoto:'lena.jpg',
        mail: <div>events.sggw@esn.pl</div>
    },
    // {
    //     name:'Piotr Rabek',
    //     position:'Fundraising Committee',
    //     description:<div><span className="bold">Hello! 👋</span><br/><br/>
    //     I'm Piotr and I study Envitonmental Engineering. I'm keen on foreign languages and sports.<br/><br/>
    //     I love learning new things so I never get bored and I bet there's always something we can fall into discussion about 😁</div>,
    //     mail: 'fr.sggw@esn.pl',
    //     photo:'piotrek.jpg',
    //     minPhoto:'piotrek_min.jpg',
    // },
    // {
    //     name:'Recruitment in progress',
    //     position:'Fundraising Committee',
    //     description:"Recruitment in progress",
    //     mail: 'fr.sggw@esn.pl',
    //     photo:'default.jpg',
    //     minPhoto:'default.jpg',
    // },
    // {
    //     name:'Recruitment in progress',
    //     position:'Travel Committee',
    //     description:"Recruitment in progress",
    //     mail: 'travel.sggw@esn.pl',
    //     photo:'default.jpg',
    //     minPhoto:'default.jpg',
    // },
    {
        name:'Marta Stępińska',
        position:'Travel Coordinator',
        description:<div>
            Hii I’m Marta 🫶 I graduated in Economics this year and I’m really excited to be the Travel Coordinator! ✈️🌍<br/>
            Outside of Travel, I love spending my free time doing creative things. I really enjoy sewing, making things out of clay and painting 🎨🧵 I also love plants and taking care of them 🌿🪴Apart from having some quiet time for myself, I also love meeting up with my friends, going out and just spending a good time together 🫶<br/>
            I’m also a huge coffee lover ☕️ and have a serious weakness for anything chocolate 🍫🤎
        </div>,
        photo:'martas.jpg',
        minPhoto:'martas.jpg',
        mail: 'travel.sggw@esn.pl'
    },
    {
        name:'Daria Redlica',
        position:'Discover Europe Coordinator',
        description:<div>
            Hi everyone, I’m Daria.<br/>
            I’m the Discover Europe Coordinator, which means I’m here to show off your artistic side and introduce the best photo contest in Europe! 📸<br/>
            Privately, I’m a Biotechnology student and a natural-born microbiologist. In my free time, I’m a dance lover, a metal music fan, and a beer enthusiast. I’m the introverted and awkward one in the team, but I’m always open to trying new stuff.✨
         </div>,
        photo:'daria.jpg',
        minPhoto:'daria.jpg',
        mail: 'travel.sggw@esn.pl'
    },
    // {
    //     name:'Julia Warchoł',
    //     position:'Bounce Group',
    //     description:<div>
    //     <span className="bold">Hello!</span><br/><br/>
    //     Im Julia and Im Mentor Programme Coordinator and also Bounce Coordinator.<br/><br/>
    //     Im 21 years old and I’m studying veterinary medicine in WULS. I love music, I play piano and I graduated from music school some time ago.<br/><br/>
    //     In my free time I enjoy watching films, meeting with my friends, reading and playing volleybal.<br/><br/>
    //     Im hoping that I will bring some good energy into ESN and a lot of good memories!
    // </div>,
    //     mail: 'bounce.sggw@esn.pl',
    //     photo:'juliaw.jpg',
    //     minPhoto:'juliaw.jpg',
    // },
    {
        name:'Igor Czarnogłowski',
        position:'Buddy Programme Coordinator',
        description:<div>Dzień Dobry!<br/>
        My name is Igor and few things that you need to know about me is: I study Computer Science, I'm currently employed as a programmer (and IT guy for everything that runs on electricity) in a small company in Warsaw, I'm member of ESN SGGW since 05.2026, I was on Erasmus in Portugal.<br/>
        Now that you have all the infromations you needed I would like to share my interests with you. I'm a big fan of basketball and I love watching all basketball related competitions (My favourite NBA team is Golden State Warriors and favourite Euroleague team is FC Barcelona). Also I would say that I'm not only programmer just because it happened to be so, but I'm actually interested in IT, especially data science and everything related to it.<br/>
        One last thing to remeber Żabson is the best polish rapper and don't listen to PR0BL3M.<br/>
        Cheers!
    </div>,
        photo:'igorc.jpg',
        minPhoto:'igorc.jpg',
        mail:'mentor.sggw@esn.pl'
    },
    {
        name:'Zuzia Sowińska',
        position:'PR Coordinator',
        description:<div>
            Hi!! I’m Zuzia!! I study Finance and Accounting, and I also work part-time as an accountant :)) Outside of university, I love textile crafts, especially knitting and crocheting. I can’t keep track of my unfinished projects, but there is always something new to make! I listen to a lot of different music genres, but right now, I’m really into k-pop. Apart from that, I really enjoy reading—even if some of the books I read are corny—and watching volleyball (I used to play, but those days are long gone).
        </div>,
        mail: 'pr.sggw@esn.pl',
        photo:'zuzia.jpg',
        minPhoto:'zuzia.jpg',
    },
    {
        name:'Karolina Szurkiewicz',
        position:'Local Education Officer',
        description:<div>
            Hey guys! My name is Karolina (or Karola to my people! 😅). I study Dietetics and I’m a total nerd about it 🤓 I adore listening to all kinds of music and psychology podcasts! I love staying up to date with new tech, but I also enjoy going for a run 😎. I really like problem-solving and helping people be part of something big. I love the atmosphere of sports events—I’m a huge fan of cheering people on! 🎉 I can also completely lose myself in art and learning languages oh! And absolutely love to travel 🧳 🚡 also generally trying new things 🤓🤙
        </div>,
        photo:'karolinas.jpg',
        minPhoto:'karolinas.jpg',
        mail:'leo.sggw@esn.pl'
    },
    {
        name:'Joanna Siatkowska',
        position:'Sports Coordinator',
        description:<div>
            Hi everyone!! My name is Asia (not like the continent tho haha). I’m currently studying finance and accounting. Apart from that I’m a movie freak so if you’re looking for someone to go to the cinema with, hit me up! When it comes to books I’m into crime novels, thrillers and sometimes strange genres. I like spending time with my friends, going to pub quizzes, silent discos and local markets. When it comes to music I find myself quite fond of rock and kpop (weird combination, I know). I enjoy travelling and meeting new people. In terms of sports I’m a huge fan of ice skating, not a big fan of falling tho.
        </div>,
        photo:'joannas.jpg',
        minPhoto:'joannas.jpg',
        mail:'pm.sggw@esn.pl'
    },
//     {
//         name:'Martyna Dwojewska',
//         position:'Social Committee',
//         description:<div>
//             <span className="bold">Hey everyone! 👋</span><br/><br/>
//             My name is Martyna. I'm 20 year-old- student of Business Management at SGGW (WULS). I joined ESN at the beginning of December 2021. Now, I'm a Mentor & Social Coordinator.<br/><br/> 
//             Besides being a student and ESNer, I'm huge sports fan. I play basketball and volleyball regularly, so we can probably meet during our sports events 😉 <br/><br/>
//             I also love reading books, watching movies, learning languages, cooking and traveling 🍽️🌏🎥📚
// </div>,
//         photo:'martynad.jpg',
//         minPhoto:'martynad_min.jpg',
//         mail: 'social.sggw@esn.pl'
//     },
    {
        name:'Zosia Lembowicz',
        position:'ESNcard coordinator',
        description:<div>
            Hii, I'm Zosia but you can also call me Sophie. I study Biotechnology so you can often find me in building 37 or the library cafe. I own two adorable orange cats and i spend most of my free time playing Genshin, Stardew Valley and many other games or reading, mostly fantasy novels and science fiction. And if not that, i am binge watching yet another tv series, be it comedy, crime or Star Wars
        </div>,
        mail: 'card.sggw@esn.pl',
        photo:'zosial.jpg',
        minPhoto:'zosial.jpg',
    },
];

// const teamMembersCount = teamMembers.length + boaMembers.length + coordinators.length;
class Team extends Component{

    constructor(props) {
        super(props)
        this.state = { 
            loading: false,
            activeCategory:'board',
            activeIndex:1,
         }
    }
    componentDidMount(){
    }

            //preload images - change logic if images taken from DB.
    toggleClicked = function(e){
        e.stopPropagation();
        e.preventDefault();
        $(e.currentTarget).toggleClass('clicked');
    }
    render(){   
        // console.log(this.state.loading);
    return ( 
        this.state.loading ? <Loading/> : 
        <div className="container team-container col-md-12 page-container">
            <h3 className="page-title visible-xs">
                Meet the team
            </h3>

            <div className="heading">
                <div className={this.state.activeIndex===0 ? "category active coordinators" :'category coordinators'} onClick={()=>{this.setState({activeIndex:0})}}>
                    <h3>Coordinators</h3>
                    <div className="astrodivider"><div className="astrodividermask"></div></div>
                </div>
                <div className={this.state.activeIndex===1 ? "category active board" :'category board'} onClick={()=>{this.setState({activeIndex:1})}}>
                    <h3>Executive Board</h3>
                    <div className="astrodivider"><div className="astrodividermask"></div></div>
                </div>
                <div className={this.state.activeIndex===2 ? "category active audit" :'category audit'}  onClick={()=>{this.setState({activeIndex:2})}}>
                    <h3>Board of Audit</h3>
                    <div className="astrodivider"><div className="astrodividermask"></div></div>
                </div>

            </div>

            <Carousel touch={false} activeIndex={this.state.activeIndex} onSelect={(index)=>{this.setState({activeIndex: index})}} interval={null}>

            <Carousel.Item>
                    <h3 className="category-name">Coordinators</h3>
                    <div className="board-members coordinators col-md-12 col-lg-12">
                        {coordinators.map(member =>{
                            return ( <div className="card" onClick={(e)=>{this.toggleClicked(e)}} key={member.name+member.position}>

                                <div className="front">
                                    <ProgressiveImage src={require('../images/teamImages/'+member.photo)} overlaySrc={require('../images/teamImages/'+member.minPhoto)} alt=""/>
                                    {/* <ProgressiveImage teamMembersCount = {teamMembersCount} updateTeamPageLoad= {this.props.updateTeamPageLoad} teamImagesLoaded={this.props.teamImagesLoaded} src={require('../images/teamImages/'+member.photo)} overlaySrc={require('../images/teamImages/'+member.minPhoto)} alt=""/> */}
                                    <div className="info-front">
                                        <div className="name">{member.name}</div>
                                        <div className="separator"></div>
                                        <div className="position">{member.position}</div>
                                        {member.mail ? <div className="mail"><a href={"mailto:"+member.mail}>{member.mail}</a></div> : null}
                                    </div>
                                </div>
                                <div className="back">
                                    <img src={require('../images/teamImages/'+member.photo)} alt="" />
                                    <div className="text">
                                        {member.description}
                                        
                                    </div>


                                </div>
                            </div> )})}
                        </div>
                </Carousel.Item>
                <Carousel.Item>
                <h3 className="category-name">Executive Board</h3>
                <div className="board-members col-md-12 col-lg-12">
                    {teamMembers.map(member =>{
                        return ( <div className="card" onClick={(e)=>{this.toggleClicked(e)}} key={member.name+member.position}>

                            <div className="front">
                                <ProgressiveImage src={require('../images/teamImages/'+member.photo)} overlaySrc={require('../images/teamImages/'+member.minPhoto)} alt="" />
                                <div className="info-front">
                                    <div className="name">{member.name}</div>
                                    <div className="separator"></div>
                                    <div className="position">{member.position}</div>
                                    {member.mail ? <div className="mail"><a href={"mailto:"+member.mail}>{member.mail}</a></div> : null}
                                </div>
                            </div>
                            <div className="back">
                                <img src={require('../images/teamImages/'+member.photo)} alt="" />
                                <div className="text">
                                    {member.description}
                                </div>
                            </div>
                        </div> )})}

                    </div>
                </Carousel.Item>

                <Carousel.Item>
                    <h3 className="category-name">Board of Audit</h3>
                    <div className="board-members audit col-md-12 col-lg-12">
                        {boaMembers.map(member =>{
                            return ( <div className="card" onClick={(e)=>{this.toggleClicked(e)}} key={member.name+member.position}>

                                <div className="front">
                                    <ProgressiveImage src={require('../images/teamImages/'+member.photo)} overlaySrc={require('../images/teamImages/'+member.minPhoto)} alt="" />
                                    <div className="info-front">
                                        <div className="name">{member.name}</div>
                                        <div className="separator"></div>
                                        <div className="position">{member.position}</div>
                                        {member.mail ? <div className="mail"><a href={"mailto:"+member.mail}>{member.mail}</a></div> : null}
                                    </div>
                                </div>
                                <div className="back">
                                    <img src={require('../images/teamImages/'+member.photo)} alt="" />
                                    <div className="text">
                                        {member.description}
                                        
                                    </div>


                                </div>
                            </div> )})}
                    </div>
                </Carousel.Item>
                </Carousel>
        </div>
     );
    }
}
 
export default Team;